import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css'],
})
export class AppErrorComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
